import React from 'react'
import { Link } from 'react-router-dom'
import * as routePaths from 'constants/routePaths'


const Login = () => {
    return(
        <div>
            login
            <Link to={routePaths.LIST}>back to list</Link>
        </div>
    )
}

export default Login
